module.exports = __webpack_public_path__ + "static/img/kv_trackplus2.415db40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/kv_trackplus2.jpg
// module id = 68va
// module chunks = 1